import React, { ComponentProps } from 'react';

import { useState } from 'react';

import Button from '../atoms/button';
import Anchor from '../atoms/anchor';
import { SubmitIdeaModal } from '../../community/SubmitIdeaModal';

type LoginOrRegisterButtonProps = {
    children: React.ReactNode;
    variant: ComponentProps<typeof Button>['variant'] | ComponentProps<typeof Anchor>['variant'];
    appearance: 'button' | 'link';
    size: ComponentProps<typeof Anchor>['size'] | ComponentProps<typeof Button>['size'];
    className?: string;
};

export const SubmitIdeaButton = ({
    children,
    variant,
    className,
    appearance,
    size,
}: LoginOrRegisterButtonProps) => {
    let [showModal, setShowModal] = useState(false);

    return (
        <div>
            {showModal && (
                <SubmitIdeaModal
                    close={() => {
                        setShowModal(false);
                    }}
                />
            )}
            {appearance === 'button' ? (
                <Button
                    className={className}
                    as="button"
                    size={size}
                    variant={variant as ComponentProps<typeof Button>['variant']}
                    onClick={() => {
                        setShowModal(true);
                    }}
                >
                    {children}11
                </Button>
            ) : (
                <Anchor
                    as="button"
                    className={className}
                    size={size}
                    variant={variant as ComponentProps<typeof Anchor>['variant']}
                    onClick={() => {
                        setShowModal(true);
                    }}
                >
                    {children}
                </Anchor>
            )}
        </div>
    );
};
